<template>
  <div>
    <h1>
      <b>Técnicos</b>
    </h1>
    <div class="form-group pull-left">
      <router-link to="/usuarios/crear">
        <button type="button" class="btn btn-success md-elevation-24">
          <i class="fa fa-plus-circle"></i> Crear técnico
        </button>
      </router-link>
    </div>
    <div>
      <div class="form-group pull-right">
        <input
          type="text"
          class="search form-control"
          v-model="filter"
          placeholder="Buscar usuario"
        />
      </div>
      <span class="counter pull-right"></span>
      <div class="row">
        <div id="table" class="col-xs-12 table-responsive">
          <datatable
            :columns="columns"
            :data="row"
            :filter-by="filter"
            class="table table-hover table-bordered results"
          >
            <template scope="{ row }">
              <tr>
                <td class="td_style">{{ row.id }}</td>
                <td class="td_style">
                  <router-link
                    :to="{
                      name: 'editar-usuario',
                      params: { userId: row.id },
                    }"
                  >
                    <a href="#">{{
                      `${row.nombre} ${row.apellidos}`
                    }}</a>
                  </router-link>
                </td>
                <td class="td_style">{{ `${row.usuario}` }}</td>
                <td class="td_style">{{ row.rol }}</td>
                <td
                  class="td_style"
                  v-if="
                    row.rol != 'ADMIN_MAIN' && row.rol != 'ANALISTA'
                  "
                >
                  <md-switch
                    @change="cambiarAsignacion(row.id, false)"
                    v-if="row.asignacion_aleatoria"
                    v-model="row.asignacion_aleatoria"
                    class="md-primary"
                    >Asignar aleatorio</md-switch
                  >
                  <md-switch
                    @change="cambiarAsignacion(row.id, true)"
                    v-if="!row.asignacion_aleatoria"
                    v-model="row.asignacion_aleatoria"
                    class="md-primary"
                    >No asignar</md-switch
                  >
                </td>
                <td class="td_style" v-else></td>
                <td>
                  <ul
                    class="pull-center panel-settings panel-button-tab-right"
                  >
                    <li class="dropdown">
                      <a
                        class="pull-center dropdown-toggle"
                        data-toggle="dropdown"
                        href="#"
                      >
                        <button class="btn btn-primary">
                          Opciones
                          <i class="fa fa-sort-down"></i>
                        </button>
                      </a>
                      <ul class="dropdown-menu dropdown-menu-right">
                        <li>
                          <ul class="dropdown-settings">
                            <router-link
                              :to="{
                                name: 'editar-usuario',
                                params: { userId: row.id },
                              }"
                            >
                              <li class="td_style">
                                <a href="#">Ver/Editar</a>
                              </li>
                            </router-link>

                            <li class="divider"></li>
                            <li
                              @click="eliminar(row.id)"
                              class="td_style"
                            >
                              <a href="#">Eliminar</a>
                            </li>
                            <li class="divider"></li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 form-inline">
          <datatable-pager
            v-model="page"
            type="abbreviated"
            :per-page="per_page"
          ></datatable-pager>
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
export default {
  name: 'usuarios',
  components: {
    Loading,
  },
  data() {
    return {
      filter: '',
      loading: true,
      columns: [
        {
          label: 'ID',
          field: 'id',
          align: 'center',
        },
        {
          label: 'NOMBRES',
          field: 'nombre',
          align: 'center',
        },
        {
          label: 'USUARIO',
          field: 'usuario',
          align: 'center',
        },
        { label: 'ROL', field: 'rol', align: 'center' },
        { label: 'ASIGNACIÓN', align: 'center' },
        { label: 'ACCIONES', align: 'center' },
      ],
      row: [],
      page: 1,
      per_page: 20,
    };
  },
  created() {
    this.getUsers();
  },
  mounted() {},
  methods: {
    onCancel() {},
    eliminar(userId) {
      let data = {
        userId: userId,
      };
      ServiceApi.post('/delete/user', data)
        .then(response => {
          //console.log('RESPUESTA:::', response)
          this.getUsers();
        })
        .catch(err => {
          this.$noty.error('Ocurrio un error al eliminar el usuario');
        });
    },
    getUsers() {
      this.loading = true;
      ServiceApi.get('/user/list')
        .then(response => {
          //console.log('RESPUESTA:::', response)
          let data = response.data.data;
          this.row = data.reverse();
          this.loading = false;
        })
        .catch(err => {
          this.$noty.error(
            'Ocurrio un error al consultar los usuarios'
          );
          this.loading = false;
          this.$router.push('/');
        });
    },
    cambiarAsignacion(userId, asignacion_aleatoria) {
      this.loading = true;
      let data = {
        userId,
        asignacion_aleatoria,
      };
      ServiceApi.post('/user/cambiar/asignacion', data)
        .then(response => {
          // console.log('RESPUESTA:::', response)
          this.row.filter(
            u => u.id === userId
          )[0].asignacion_aleatoria = asignacion_aleatoria;
          this.loading = false;
        })
        .catch(err => {
          this.$noty.error(
            'Ocurrio un error al consultar los usuarios'
          );
          this.loading = false;
          this.$router.push('/');
        });
    },
  },
};
</script>
